var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "calendar-hour d-flex align-items-center justify-content-center",
        class: _vm.isMobile ? "columna-fija" : ""
      },
      [
        _c("div", { staticClass: "font-weight-bold" }, [
          _vm._v(" " + _vm._s(_vm.hour?.name) + " ")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }